import React from "react";

const LoaderBTN = ({ msg }) => {
  return (
    <button
      className="w-[118px] text-center px-4 py-3 text-[#475467] text-[12px] font-[600] rounded-lg border border-[#D0D5DD] bg-[#F9FAFB] ipad:w-[90px] ipad:py-2 cursor-not-allowed flex items-center justify-center gap-2"
      type="button"
      disabled
    >
      <div className="enterprise-loader enterprise-loader--sm" aria-hidden="true" />
      {msg}
    </button>
  );
};

export default LoaderBTN;
